import { render } from "./SessionTimeout.vue?vue&type=template&id=64c5c59b"
import script from "./SessionTimeout.vue?vue&type=script&lang=js"
export * from "./SessionTimeout.vue?vue&type=script&lang=js"

import "./SessionTimeout.vue?vue&type=style&index=0&id=64c5c59b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__